import React, { useState } from "react";
import { AiOutlineMinus } from "react-icons/ai";
import { HiOutlineUpload, HiTrash } from "react-icons/hi";
import Swal from "sweetalert2";
import Loader from "../shared/Loader/Loader";
const imageStoraeKey = `347525e64775187aed4d03329dbe793a`;

const FileTag = ({
  name,
  defaultValue,
  multiple,
  label,
  length,
  required,
  handleSingleDelete,
  isGalleryFile,
  fullHeight,
}) => {
  const [value, setValue] = useState(defaultValue?.url);
  const [preview, setPreview] = useState(defaultValue?.url);
  const [loading, setLoading] = useState(false);
  const [visibility, setVisibility] = useState(true);

  const handleFileChange = async (event) => {
    const image = event.target.files[0];
    const formData = new FormData();
    formData.append("image", image);
    const url = `https://api.imgbb.com/1/upload?key=${imageStoraeKey}`;
    setLoading(true);
    await fetch(url, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          setValue(result.data.url);
          setLoading(false);
        }
      });

    setPreview(URL.createObjectURL(event.target.files[0]));
  };

  const handleDelete = async () => {
    if (isGalleryFile) {
      setVisibility(false);
    } else {
      const res = await handleSingleDelete(defaultValue._id);
      if (typeof res === "boolean" && res === true) {
        setVisibility(false);
      }
    }
  };

  // remove image from ui with confirmation
  const removeImgHandler = (event) => {
    if (!preview) return;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes!",
    }).then((result) => {
      if (result.isConfirmed) {
        setValue(false);
        setPreview(false);
      }
    });
  };

  return (
    <div key={Math.random()} className={visibility ? "w-full" : "hidden"}>
      {/* inner container */}
      <div className="w-full relative flex flex-col items-center gap-4">
        {/* container with label */}
        <div className="flex gap-2 items-center flex-col">
          {/* Label */}
          <div className="w-full font-semibold text-left ssm:text-left cursor-default capitalize text-darkPrimary dark:text-darkWhite">
            {length ? label + " " + length : label}
          </div>

          {/* image & btn container */}
          <div className="flex flex-col gap-2 sm:flex-row items-center">
            <div
              className={`${
                fullHeight
                  ? "h-auto min-h-[6.4rem] lg:min-h-[15rem] p-1.5 bg-gray-300 dark:bg-darkPrimary dark:border-gray-700 dark:text-darkWhite text-gray-700 "
                  : "h-24 xs:h-36 sm:h-28 md:h-32 sLg:h-48 lg:h-52 p-4 bg-gray-300 text-gray-700 "
              } border w-36 sm:w-32 sLg:w-60 lg:w-60 relative flex items-center justify-center rounded-lg overflow-hidden`}
            >
              {preview ? (
                <img
                  src={preview}
                  alt=""
                  className={`w-full h-full object-contain ${
                    fullHeight ? "rounded" : ""
                  }`}
                />
              ) : (
                <span className="text-[10px] xxs:text-sm text-center p-1">
                  No image selected
                </span>
              )}
              {loading && (
                <div
                  className={`z-10 absolute inset-0 flex items-center justify-center ${
                    fullHeight
                      ? "bg-gray-400 dark:bg-darkPrimary"
                      : "bg-gray-400"
                  }`}
                >
                  <Loader />
                </div>
              )}
            </div>
            {/* Buttons in label */}
            <div className="flex flex-col gap-0.5 sm:gap-1 items-center">
              <label className="px-2.5 py-2">
                {/* Change/Upload button */}
                <span
                  title="pick a new image"
                  className="px-2.5 py-2 border dark:border-darkBorder dark:hover:bg-darkPrimary rounded-md cursor-pointer bg-secondary/70 hover:bg-secondary text-primary border-secondary/10 hover:border-secondary transition duration-150 flex items-center gap-1"
                >
                  {preview ? "Change" : "Upload"}
                  <HiOutlineUpload className="inline" />
                </span>
                {/* hidden input */}
                <input
                  onChange={handleFileChange}
                  type="file"
                  name={visibility ? name : ""}
                  className="hidden"
                  src={value ? value : null}
                  alt={defaultValue?._id ? defaultValue?._id : ""}
                  accept="image/png, image/gif, image/jpeg, image/jpg, image/webp"
                />
              </label>
              {/* Remove button */}
              <button
                type="button"
                onClick={removeImgHandler}
                title="remove selected image"
                className="px-2.5 py-2 border border-gray-300 text-gray-600 dark:text-darkWhite dark:border-darkBorder dark:hover:bg-darkPrimary rounded-md hover:bg-primary transition duration-150 flex items-center gap-1"
              >
                Remove
                <HiTrash />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className={!multiple ? "hidden" : ""}>
        <button
          type="button"
          onClick={handleDelete}
          className="btn btn-sm btn-circle border border-gray-400 rounded-full mt-8 p-2 hover:bg-gray-50"
          title="Remove"
        >
          <AiOutlineMinus />
        </button>
      </div>
    </div>
  );
};

export default FileTag;
